// extracted by mini-css-extract-plugin
export default {"legendButton":"LegendButton_legendButton__ptJJI","legendButtonWarning":"LegendButton_legendButtonWarning__+4kQY"};